import { axiosPrivate } from "../config/axios";
import { IChangePassword } from "../models/account";
import { errorApi, successApi } from "./handle.response.api";

export const getDetailAccount = async (accountId: string) => {
  try {
    const res = await axiosPrivate.get(`/accounts/${accountId}`);
    return successApi(res?.data);
  } catch (error: any) {
    return errorApi("Lấy chi tiết chuyến đi thất bại", error?.response?.data?.message);
  }
};
export const changePasswordAccount = async (
  accountId: string,
  payload: IChangePassword
) => {
  try {
    const res = await axiosPrivate.put(
      `/accounts/password/${accountId}`,
      payload
    );
    return successApi(res?.data);
  } catch (error: any) {
    return errorApi("Đổi mật khẩu thất bại", error?.response?.data?.message);
  }
};
